import { type INote, type IScoreboard, type ITimelineItem } from '@/types/INote';

const BYTE = {
  LF: '\x0A',
  NULL: '\x00',
};

export const findNote = <T extends INote | ITimelineItem>(notes: T[], newNote: T) => {
  return notes.find((n: T) => n.id === newNote.id);
};

export const updateNotes = <T extends INote | ITimelineItem>(notes: T[], newNote: T): T[] => {
  return notes.map((n: T) => {
    if (n.id === newNote.id) {
      /**
       * @info
       * _updateTimestamp is used to determine if the note was updated,
       * therefore rerender the proper component using id and _updateTimestamp as a key.
       */
      return { ...newNote, _updateTimestamp: Date.now() };
    } else {
      return n;
    }
  });
};

export const deleteNote = <T extends INote | ITimelineItem>(list: T[], id: string) => {
  return list.filter((e: T) => e.id !== id);
};

export const prepareData = (data?: string): INote | IScoreboard | null => {
  if (data?.trim()) {
    try {
      const parts: string[] = data.split('\n\n');
      const body: string = parts[1].replace(BYTE.NULL, '');

      if (body) {
        return JSON.parse(body);
      }
    } catch {
      return null;
    }
  }

  return null;
};

export const WSFrame = (command: string, headers: { [key: string]: string }) => {
  return (
    command.toUpperCase() +
    BYTE.LF +
    Object.keys(headers)
      .map((e) => e + ':' + headers[e])
      .join(BYTE.LF) +
    BYTE.LF +
    BYTE.LF +
    BYTE.NULL
  );
};
